<template>
    <div class="content-teaser grid grid__base"
            :class="[bemFacets, paneClasses]"
            @mouseover="onActivatePane(true)"
            @mouseleave="onActivatePane(false)"
    >
        <div class="content-teaser--row">
            <div class="content-teaser--col content-teaser--left-pane">
                <div class="content-teaser--image-wrapper">
                    <slot name="image">
                        <div class="content-teaser--image-background"/>
                    </slot>
                </div>
            </div>

            <div class="content-teaser--col content-teaser--right-pane">
                <div class="content-teaser--content-wrapper">
                    <slot name="right-pane-content">
                        <div class="content-teaser--content">
                            <div class="content-teaser--title">
                                <slot name="title"/>
                            </div>

                            <div class="content-teaser--content-text">
                                <slot name="content"/>
                            </div>

                            <div class="content-teaser--links">
                                <slot name="links"/>
                            </div>
                        </div>
                    </slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import bemMixin from 'framework/mixins/bem';

    export default {
        mixins: [bemMixin('content-teaser')],

        data() {
            return {
                isActive: false,
            };
        },

        computed: {

            paneClasses() {
                return [
                    this.isActive ? 'content-teaser__active' : null,
                ];
            },
        },

        methods: {
            onActivatePane(isActive) {
                this.isActive = isActive;
            },
        },
    };
</script>
